export default "__VITE_ASSET__25e54e4f__"